<!-- Template per PDF Viewer normale -->
<ng-template #pdfViewerTpl>
  <sia-pdf-viewer
    [file]="pdfBlob()"
    [initialZoom]="1"
    (matchesCountChange)="onPdfMatchesCountChange($event)"
  ></sia-pdf-viewer>
</ng-template>

<!-- Template per PDF Viewer fullscreen (zoom ridotto) -->
<ng-template #pdfViewerFullscreenTpl>
  <sia-pdf-viewer
    [file]="pdfBlob()"
    [initialZoom]="0.5"
    (matchesCountChange)="onPdfMatchesCountChange($event)"
  ></sia-pdf-viewer>
</ng-template>

<!-- Template per Email Preview -->
<ng-template #emailPreviewTpl>
  <sia-file-preview-email [bodyHtml]="emailBodyHtml()"></sia-file-preview-email>
</ng-template>

<!-- Template per Text Preview -->
<ng-template #textPreviewTpl>
  <div class="h-full w-full overflow-auto" [innerHTML]="textHtml() | safeHtml"></div>
</ng-template>

<!-- Template per fullscreen overlay -->
<ng-template #fullscreenOverlayTpl let-content>
  <div class="fixed inset-0 z-[9999] flex items-center justify-center" (click)="toggleFullscreen()">
    <!-- Backdrop con blur -->
    <div class="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>

    <!-- Popup container con sfondo di sistema -->
    <div
      class="surface relative z-10 flex h-[85vh] w-[90vw] flex-col overflow-hidden rounded-xl shadow-2xl"
      (click)="$event.stopPropagation()"
    >
      <div class="w-full" #header>
        <ng-container [ngTemplateOutlet]="headerActionTemplate"></ng-container>
      </div>

      <!-- Content Area -->
      <div class="w-full flex-1 overflow-auto p-4" [style.height]="'calc(100% - ' + header.offsetHeight + 'px)'">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<!-- Template per file non supportato -->
<ng-template #unsupportedFileTpl let-icon="icon" let-message="message">
  <div
    class="flex h-full min-h-[200px] flex-col items-center justify-center gap-4 rounded border border-dashed border-gray-300 bg-gray-100 p-6"
  >
    <mat-icon class="h-12! w-12! text-5xl! text-gray-400">{{ icon }}</mat-icon>
    <span class="text-center text-sm text-gray-500">{{ message }}</span>
    @if (canDownload()) {
      <button mat-stroked-button (click)="downloadFile()" class="mt-2">
        <mat-icon class="mr-2">download</mat-icon>
        Scarica file
      </button>
    }
  </div>
</ng-template>

<ng-template #defaultUnsupportedFileTpl>
  <ng-container
    *ngTemplateOutlet="
      unsupportedFileTpl;
      context: {
        icon: 'insert_drive_file',
        message: 'Tipo di file non supportato',
      }
    "
  ></ng-container>
</ng-template>

@if (isLoading()) {
  <div class="flex h-full min-h-[200px] w-full items-center justify-center">
    <mat-spinner diameter="48"></mat-spinner>
  </div>
}

@if (!isLoading() && previewLoaded()) {
  <div class="flex h-full w-full flex-col">
    <div class="h-fit w-full" #action>
      @if (isOcrExpanded() || !['xls', 'xlsx'].includes(previewFileType())) {
        <ng-container [ngTemplateOutlet]="headerActionTemplate"></ng-container>
      }
    </div>

    <div
      #previewContainer
      class="min-h-0 flex-1 overflow-auto px-2"
      [style.height]="'calc(100% - ' + action.offsetHeight + 'px)'"
    >
      @if (!isOcrExpanded()) {
        @switch (previewFileType()) {
          @case ('pdf') {
            @if (pdfBlob()) {
              @if (isFullscreenMode()) {
                <ng-container
                  *ngTemplateOutlet="fullscreenOverlayTpl; context: { $implicit: pdfViewerFullscreenTpl }"
                ></ng-container>
              } @else {
                <ng-container *ngTemplateOutlet="pdfViewerTpl"></ng-container>
              }
            } @else {
              <sia-file-preview-image
                [(imagesUrls)]="imagesUrl"
                [(fullscreen)]="isFullscreenMode"
                [horizontal]="horizontal()"
              ></sia-file-preview-image>
            }
          }
          @case ('xls') {
            <sia-file-preview-excel
              [sheets]="excelSheets()"
              [(fullscreen)]="isFullscreenMode"
              [actionsTemplate]="headerActionTemplate"
              (sheetChanged)="onExcelSheetChanged()"
            ></sia-file-preview-excel>
          }
          @case ('xlsx') {
            <sia-file-preview-excel
              [sheets]="excelSheets()"
              [(fullscreen)]="isFullscreenMode"
              [actionsTemplate]="headerActionTemplate"
              (sheetChanged)="onExcelSheetChanged()"
            ></sia-file-preview-excel>
          }
          @case ('doc') {
            <sia-file-preview-word
              [fileBlob]="wordBlob()"
              [(fullscreen)]="isFullscreenMode"
              [actionsTemplate]="headerActionTemplate"
              (loaded)="onWordLoaded()"
            ></sia-file-preview-word>
          }
          @case ('docx') {
            <sia-file-preview-word
              [fileBlob]="wordBlob()"
              [(fullscreen)]="isFullscreenMode"
              [actionsTemplate]="headerActionTemplate"
              (loaded)="onWordLoaded()"
            ></sia-file-preview-word>
          }
          @case ('eml') {
            @if (isFullscreenMode()) {
              <ng-container
                *ngTemplateOutlet="fullscreenOverlayTpl; context: { $implicit: emailPreviewTpl }"
              ></ng-container>
            } @else {
              <sia-file-preview-email [bodyHtml]="emailBodyHtml()"></sia-file-preview-email>
            }
          }
          @case ('msg') {
            @if (isFullscreenMode()) {
              <ng-container
                *ngTemplateOutlet="fullscreenOverlayTpl; context: { $implicit: emailPreviewTpl }"
              ></ng-container>
            } @else {
              <sia-file-preview-email [bodyHtml]="emailBodyHtml()"></sia-file-preview-email>
            }
          }
          @case ('text') {
            @if (isFullscreenMode()) {
              <ng-container
                *ngTemplateOutlet="fullscreenOverlayTpl; context: { $implicit: textPreviewTpl }"
              ></ng-container>
            } @else {
              <ng-container *ngTemplateOutlet="textPreviewTpl"></ng-container>
            }
          }
          @default {
            @if (isNativeImagePreview()) {
              <sia-file-preview-image
                [(imagesUrls)]="imagesUrl"
                [(fullscreen)]="isFullscreenMode"
                [horizontal]="horizontal()"
                [actionsTemplate]="headerActionTemplate"
              ></sia-file-preview-image>
            } @else {
              @if (isFullscreenMode()) {
                <ng-container
                  *ngTemplateOutlet="fullscreenOverlayTpl; context: { $implicit: defaultUnsupportedFileTpl }"
                ></ng-container>
              } @else {
                <ng-container *ngTemplateOutlet="defaultUnsupportedFileTpl"></ng-container>
              }
            }
          }
        }
      } @else {
        @if (isFullscreenMode()) {
          <ng-container *ngTemplateOutlet="fullscreenOverlayTpl; context: { $implicit: ocrViewerTpl }"></ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="ocrViewerTpl"></ng-container>
        }

        <ng-template #ocrViewerTpl>
          <div class="h-full w-full overflow-auto p-2 whitespace-pre-wrap">
            <span [innerHTML]="ocrTextContent() | safeHtml"> </span>
          </div>
        </ng-template>
      }
    </div>
  </div>
}

<ng-template #headerActionTemplate>
  <div class="flex items-center justify-end gap-2 p-2">
    @if (!isNativeImagePreview()) {
      <div
        class="mr-2 flex w-64 flex-shrink items-center rounded-full border border-gray-200 bg-white px-3 py-1 pr-1 shadow-sm transition-all sm:w-80 dark:border-gray-700 dark:bg-[var(--mat-sys-surface-container-highest)]"
      >
        <mat-icon class="mr-2 shrink-0 text-[20px] text-gray-400">search</mat-icon>
        <input
          #searchInput
          type="text"
          [(ngModel)]="searchText"
          (keyup.enter)="onSearchEnter()"
          (ngModelChange)="onSearchChange()"
          placeholder="Cerca nel documento..."
          class="min-w-0 flex-1 bg-transparent text-sm outline-none dark:text-gray-200"
        />
        @if (totalMatches() > 0) {
          <span class="ml-2 text-xs whitespace-nowrap text-gray-500">
            {{ currentMatchIndex() + 1 }} / {{ totalMatches() }}
          </span>
        }
        <div class="ml-2 flex items-center border-l border-gray-200 pl-1 dark:border-gray-600">
          <button mat-icon-button class="h-6! w-6!" (click)="performSearch(true, 'findagain')" matTooltip="Precedente">
            <mat-icon class="text-[20px] leading-none text-gray-500">keyboard_arrow_up</mat-icon>
          </button>
          <button mat-icon-button class="h-6! w-6!" (click)="performSearch(false, 'findagain')" matTooltip="Successivo">
            <mat-icon class="text-[20px] leading-none text-gray-500">keyboard_arrow_down</mat-icon>
          </button>
          @if (searchText()) {
            <button
              mat-icon-button
              class="ml-1 h-6! w-6! text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
              (click)="clearSearch()"
              matTooltip="Cancella ricerca"
            >
              <mat-icon class="text-[20px] leading-none">close</mat-icon>
            </button>
          }
        </div>
      </div>
    }

    @if (showOcr()) {
      <button mat-icon-button (click)="toggleOcr()" matTooltip="Visualizza OCR">
        <mat-icon>document_scanner</mat-icon>
      </button>
    }
    @if (canDownload()) {
      <button mat-icon-button (click)="downloadFile()" matTooltip="Scarica file">
        <mat-icon>download</mat-icon>
      </button>
    }
    @if (showFullscreen()) {
      @if (!isFullscreenMode()) {
        <button mat-icon-button (click)="toggleFullscreen()" matTooltip="Schermo intero">
          <mat-icon>expand_content</mat-icon>
        </button>
      } @else {
        <button mat-icon-button (click)="toggleFullscreen()" matTooltip="Chiudi">
          <mat-icon>close</mat-icon>
        </button>
      }
    }
  </div>
</ng-template>
